export default __webpack_public_path__ + "static/20-ea4065ad10c548fbdf4132f795a4fb17.png";